/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { ContentController, CreateContentControllerDeps, Spot, SpotContent } from "."
 */

/**
 * @param {Spot<SpotContent | null>} spot
 * @param {CreateContentControllerDeps} createContentControllerDeps
 * @returns {ContentController}
 */
export function createContentController(
  spot,
  { contentControllerFactory, contentInfo, el }
) {
  const { content, duration, volume } = spot;
  return contentControllerFactory.create(el, content?.model ?? null, {
    contentInfo,
    volume,
    trackDuration: duration / 1000
  });
}
